import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ojxcayuxakdkuqzpvpfp.supabase.co';
const supabaseKey = 'sb_publishable_JgMiwNrrqVkutU3wEL9g-w_7QAucjPC';

export const supabase = createClient(supabaseUrl, supabaseKey);
